import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AnimationService } from 'src/app/utils/animation.service';

@Component({
  selector: 'app-intro-benefits',
  templateUrl: './intro-benefits.component.html',
  styleUrls: ['../home.component.scss', './intro-benefits.component.scss']
})
export class IntroBenefitsComponent implements OnInit {
  
  @ViewChild('animation')
  animation: ElementRef;

  constructor(private animations: AnimationService) { }

  ngOnInit(): void {
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
    this.animations.startRightToLeftAnimation(this.animation.nativeElement);
  }
}
